import { runInAction, action, observable, makeObservable } from "mobx";
import { apiRequest } from "../utils/api";
import globals from "../globals";

class ArchivosStore {
    @observable bannersDesktop = [];
    @observable bannersMobile = [];
    @observable logoWeb;
    queryController;
    cache = {};

    constructor() {
        makeObservable(this);
        this.traerLogoWeb();
        this.traerBanners();
    }

    traerLogoWeb() {
        if (globals.LOGO) {
            this.logoWeb = globals.LOGO;
            return;
        }
        const that = this;
        apiRequest('/archivos/logoweb', {}, {method: 'GET'})
            .then(data => { runInAction(() => { that.logoWeb = data.data[0].url; });
            }).catch((err) => { console.error(err); });
    }

    traerBanners() {
        const that = this;
        apiRequest('/archivos/bannerdesktop', {}, {method: 'GET'})
            .then(data => { runInAction(() => { that.bannersDesktop = data.data; });
            }).catch((err) => { console.error(err); });
        apiRequest('/archivos/bannermobile', {}, {method: 'GET'})
            .then(data => { runInAction(() => { that.bannersMobile = data.data; });
            }).catch((err) => { console.error(err); });
    }
}
const archivosStore = new ArchivosStore();
export default archivosStore;